import { render, staticRenderFns } from "./menuLeadActions.vue?vue&type=template&id=b8313d5e"
import script from "./menuLeadActions.vue?vue&type=script&lang=js"
export * from "./menuLeadActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports